import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import { IconButton, Typography } from '@material-ui/core'
import IconBack from '@material-ui/icons/ArrowBack'
import {
  licenseeFetchFormData,
  licenseeChange,
  licenseeClearStateForm,
} from 'reducers/licensee/reducer'
import { fetchProfile } from 'reducers/profile/reducer'
import LicenseeForm from 'components/licensee/LicenseeForm'
import withPromise from 'helpers/withPromise'
import { removeUnnecessaryProps } from 'helpers/formatter'
import messages from 'components/licensee/translate'

class LicenseeItem extends Component {
  constructor(props) {
    super(props)
    this.state = {
      licenseeError: null,
    }
  }

  componentDidMount() {
    const { licenseeFetchFormData } = this.props

    licenseeFetchFormData({
      entityId: this.getEntityId(),
    })
  }

  componentWillUnmount() {
    const { licenseeClearStateForm } = this.props

    licenseeClearStateForm()
  }

  getEntityId() {
    const {
      match: {
        params: { id },
      },
    } = this.props

    return id !== 'create' ? id : 0
  }

  onSubmit = values => {
    const {
      licenseeChange,
      fetchProfile,
      history: { goBack },
    } = this.props
    const removeParamKeys = ['copyDataFrom']
    const newData = removeUnnecessaryProps(values, removeParamKeys)

    if (newData.mobileJobSyncDaysPast !== undefined) {
      newData.mobileJobSyncDaysPast = parseInt(
        newData.mobileJobSyncDaysPast,
        10,
      )
    }
    if (newData.mobileJobSyncDaysAhead !== undefined) {
      newData.mobileJobSyncDaysAhead = parseInt(
        newData.mobileJobSyncDaysAhead,
        10,
      )
    }

    return withPromise(licenseeChange, {
      entityId: this.getEntityId(),
      values: newData,
    })
      .then(errors => {
        if (errors) {
          this.setState({ licenseeError: errors.name })
          Promise.resolve(errors)
        } else {
          goBack()
        }
      })
      .then(() => {
        fetchProfile()
      })
  }

  render() {
    const {
      formData,
      history: { goBack },
    } = this.props
    const { licenseeError } = this.state

    return (
      <div className="container-fluid no-breadcrumb">
        <Typography variant="h5" className="headline">
          <IconButton size="medium" className="btn-back" onClick={goBack}>
            <IconBack fontSize="small" />
          </IconButton>
          <FormattedMessage {...messages.licenseeInfo} />
        </Typography>
        <LicenseeForm
          formData={formData}
          licenseeError={licenseeError}
          onSubmit={this.onSubmit}
        />
      </div>
    )
  }
}

LicenseeItem.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
  }).isRequired,
  history: PropTypes.shape({
    goBack: PropTypes.func,
  }).isRequired,
  formData: PropTypes.object.isRequired,
  licenseeFetchFormData: PropTypes.func,
  licenseeClearStateForm: PropTypes.func,
  licenseeChange: PropTypes.func,
  fetchProfile: PropTypes.func,
}

LicenseeItem.defaultProps = {
  licenseeFetchFormData: () => {},
  licenseeClearStateForm: () => {},
  licenseeChange: () => {},
  fetchProfile: () => {},
}

export default connect(
  state => ({
    formData: state.getIn(['licensee', 'formData']).toJS(),
  }),
  {
    licenseeFetchFormData,
    licenseeClearStateForm,
    licenseeChange,
    fetchProfile,
  },
)(LicenseeItem)
